import { useState } from 'react'
import { CloseOutlined, PhoneFilled } from '@ant-design/icons'
import { useIncomingCallActions } from '@/hooks/useIncomingCallActions'
import { getAvatarUrl } from '@/lib/image'
import { getEnvConfig } from '@/lib/runtime-env'
import { useAuthStore } from '@/store/authStore'
import { CallSurface } from './CallSurface'
import { CallSurfaceTopBar } from './CallSurfaceTopBar'
import { CallUserProfile } from './CallUserProfile'

export function IncomingCallModal() {
  const { incomingCall, pendingAction, sdkLoading, acceptCall, rejectCall } = useIncomingCallActions()
  const anchorAvatar = useAuthStore((state) => state.anchor?.avatar)
  const [isCompact, setIsCompact] = useState(false)

  if (!incomingCall) {
    return null
  }

  const callerName = incomingCall.nickname || 'Incoming call'
  const anchorImage = getAvatarUrl(anchorAvatar, getEnvConfig().CDN_URL)
  const rejectDisabled = pendingAction === 'accept'
  const acceptDisabled = pendingAction === 'reject' || sdkLoading

  const controls = (
    <>
      <div className="incoming-call-actions">
        <button
          className="incoming-call-action incoming-call-action-reject"
          disabled={rejectDisabled}
          type="button"
          aria-label="Reject"
          onClick={() => void rejectCall()}
        >
          {pendingAction === 'reject' ? <span className="incoming-call-spinner" /> : <CloseOutlined />}
        </button>
        <button
          className="incoming-call-action incoming-call-action-accept"
          disabled={acceptDisabled}
          type="button"
          aria-label="Accept"
          onClick={() => void acceptCall()}
        >
          {pendingAction === 'accept' || sdkLoading ? <span className="incoming-call-spinner" /> : <PhoneFilled />}
        </button>
      </div>

      <div className="incoming-call-action-labels" aria-hidden="true">
        <span>Reject</span>
        <span>Accept</span>
      </div>
    </>
  )

  return (
    <CallSurface
      ariaLabel="Incoming call"
      compact={isCompact}
      mediaImage={anchorImage}
      top={
        <CallSurfaceTopBar
          compact={isCompact}
          summaryUserID={incomingCall.user_id || incomingCall.from_user_id}
          onToggleCompact={() => setIsCompact((value) => !value)}
        />
      }
      profile={<CallUserProfile avatar={incomingCall.avatar} name={callerName} subtitle="Invites you to a video call" />}
      controls={controls}
      variant="incoming"
    />
  )
}
